import _ from "../../utils/underscore";
import Device from "../../utils/device/device";
import {KEY_NAME, ON_DEMAND} from "./native/native_const";
import Event from "../../utils/event";
import {SYSTEM_EVENTS} from "../../events/events";
import BaseObject from "../../base/base_object";


export class WaitForHybridGameStepLogicHandler extends BaseObject {
    static CLASS = 'WaitForHybridGameLogicHandler';

    _startTime = 0;
    _folderStruct;
    _sharedFolder;
    _gameType;
    _vendorName = '';
    _companyName = ''
    serviceFactory = null;

    init(params) {
        super.init(params);
        this.serviceFactory = params.serviceFactory;
        this._folderStruct = params.folderStruct;
        this._sharedFolder = params.sharedFolder;
        this._gameType = params.gameType;
        this._vendorName = params.vendorName;
        this._companyName = params.companyName;
    }

    run() {

        const hybrid = this.serviceFactory.hybridService();

        if (Device.hybrid.isEmbedded && hybrid.isOnDemandHtmlGame(this._gameType)) {

            this._startTime = new Date();

            this._sendAnalytics(ON_DEMAND.GAME_LOADING_START, `${this._companyName}_${this._vendorName}_${this._gameType}`);

            return hybrid.waitForOnDemandId(this._gameType, this._folderStruct, this._sharedFolder, this._vendorName).then(data => {

                let json = _.safeJSONandDecode(data);
                let error = json[KEY_NAME.ERROR];
                if (error !== 0) {
                    this._onerror(json, this._gameType , error);
                }

                hybrid.saveOnDemandLoadedGame(this._gameType,this._sharedFolder);
                this._sendAnalytics(ON_DEMAND.GAME_LOADING_END, `${this._companyName}_${this._vendorName}_${this._gameType}`);
            });
        }else {
            return Promise.resolve();
        }
    }

    _onerror(json, gameType, error) {
        let data = json[KEY_NAME.DATA];
        let action = ON_DEMAND.GAME_LOADING_ERROR;
        if (data) {
            if (data[KEY_NAME.CLOSE_BY_X]) {
                action = ON_DEMAND.GAME_LOADING_CLOSE_BY_X;
            } else if (data[KEY_NAME.CLOSE_BY_TIME_OUT]) {
                action = ON_DEMAND.GAME_LOADING_CLOSE_BY_TIME_OUT;
            } else if (data[KEY_NAME.CLOSE_BY_LOW_DISK_SPACE]) {
                action = ON_DEMAND.GAME_LOADING_CLOSE_BY_LOW_DISK_SPACE;
                Event.fire(SYSTEM_EVENTS.ODR_CLEAR_ALL_GAMES);
            } else if (data[KEY_NAME.CLOSE_NO_CHILL]) {
                action = ON_DEMAND.GAME_LOADING_CLOSE_BY_NO_CHILL;
            }
        }


        this._sendAnalytics(action, gameType,error);
        this._writeToLog(action, gameType, error);

        throw new Error('WaitForHybridGameStep ' + action + 'error:' + error);
    }

    _getTime() {
        return Math.floor(((new Date()).getTime() - this._startTime.getTime()) / 1000);
    }

    _writeToLog(action, gameType, error) {
        let nTime = this._getTime();
        this.logger.error('Failed to load game from on demand: ' + action + ' gameType: ' + gameType + ' sec: ' + nTime +"error:" ,error);
    }

    _sendAnalytics(action, gameType, error) {
        let nTime = this._getTime();
        let errorMsg = '';
        if(error){
            errorMsg = ' error msg:' + error;
        }

        let obj = {
            category: ON_DEMAND.ON_DEMAND_CATEGORY,
            action: action,
            label: gameType + errorMsg,
            value: nTime
        };

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, obj);
    }
}